$(document).ready(function (){

    $("#table-pages-authors tbody").on('click','.open-modal-sections', function (){
        let id = $(this).data('id')
        $(".item-id").val(id)
        $("#modal-sections").modal('show')
        viewTable(id)
    })

    $("#form-section-pages").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'/admin/add-section-page')
    })

    function viewTable(id) {
        $("#table-section-pages").DataTable().destroy();
        $("#table-section-pages").DataTable({
            proccesing: true,
            serverSide: true,
            language: {
                url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
            },
            responsive: true,
            ajax: 'admin/get-section-pages/'+id,
            columns: [
                {data: 'id', id: 'id'},
                {data: 'page_section.description', id: 'page_section.description'},
            ],
            "columnDefs": [{
                "targets": 2,
                "data": "download_link",
                "render": function (data, type, row, meta) {
                    return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                        'delete-section-page btn-sm m-1"' +
                        'data-id ="' + row.id + '"><i class="fa-solid fa-trash-can"></i></button>'
                }
            }]
        })
    }

    $("#table-section-pages").on('click','.delete-section-page', function (){
        let data = new FormData
        let id = $(this).data('id')
        data.append('id',id)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,"/admin/delete-section-page/"+id)
            }
        })
    })

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $(".item-image").val('')
                        $("#table-section-pages").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var errors = errors.responseJSON.errors;
                $.each(errors, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }
})

